import React from 'react';
import styled from 'styled-components';

const PremiumButton = ({ onClick, disabled, children }) => {
  return (
    <StyledWrapper>
      <button className="Btn" onClick={onClick} disabled={disabled}>
        <span className="Btn-content">{children}</span>
      </button>
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  .Btn {
    width: 140px;
    height: 40px;
    border: none;
    border-radius: 10px;
    background: linear-gradient(to right,#77530a,#ffd277,#77530a,#77530a,#ffd277,#77530a);
    background-size: 250%;
    background-position: left;
    color: #ffd277;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition-duration: 1s;
    overflow: hidden;
  }

  .Btn::before {
    position: absolute;
    content: "";
    width: 97%;
    height: 90%;
    border-radius: 8px;
    transition-duration: 1s;
    background-color: rgba(0, 0, 0, 0.842);
    background-size: 200%;
    pointer-events: none;
  }

  .Btn-content {
    position: relative;
    z-index: 1;
    color: #ffd277;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
  }

  .Btn:hover {
    background-position: right;
    transition-duration: 1s;
  }

  .Btn:hover::before {
    background-position: right;
    transition-duration: 1s;
  }

  .Btn:active {
    transform: scale(0.95);
  }

  .Btn:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }`;

export default PremiumButton;
